/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetIncidentRequest} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'
import {GetIncidentResponse} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'


export const getIncident = (request: GetIncidentRequest, options?: CashRequestOptions) => post<GetIncidentRequest, GetIncidentResponse>("/2.0/cash/get-incident", request, {...options, rejectOnError: true })